import React from 'react';
import { ProgressiveImage } from '../ProgressiveImage';
import Icon from '../Icon';
import gunsImageSrc from '../../assets/images/prelander/v6/guns.png';
import styles from './PremiumInformationStage.css';

function PremiumInformationStage() {
    return (
        <div className={styles.root}>
            <div className={styles.imageWrapper}>
                <ProgressiveImage
                    alt='player'
                    src={gunsImageSrc}
                    className={styles.image}
                />
            </div>
            <div className={styles.plans}>
                <div className={styles.regularPlan}>
                    <p className={styles.title} style={{color: 'var(--dark-fourth-new-color)'}}>Regular user</p>
                    <ul className={styles.features}>
                        <li className={styles.feature} style={{color: 'var(--tertiary-color)'}}>
                            <Icon type='play' />
                            <span className={styles.description}>Free and fair to play game for all</span>
                        </li>
                        <li className={styles.feature} style={{color: 'var(--fourth-color)'}}>
                            <Icon type='noPremiumDiamond' />
                            <span className={styles.description}>Regular tools, no bonuses, no special prices or discounts</span>
                        </li>
                    </ul>
                </div>
                
                <div className={styles.premiumPlan}>
                    <p className={styles.title} style={{color: 'var(--premium-solid-color)'}}>Powerplay premium user</p>
                    <ul className={styles.features}>
                        <li className={styles.feature} style={{color: 'var(--tertiary-color)'}}>
                            <Icon type='play' />
                            <span className={styles.description}>Free and fair to play game for all</span>
                        </li>
                        <li className={styles.feature} style={{color: 'var(--premium-solid-color)'}}>
                            <Icon type='premiumDiamond' />
                            <span className={styles.description}>Advanced premium tools and analytics data</span>
                        </li>
                        <li className={styles.feature} style={{color: 'var(--premium-solid-color)'}}>
                            <Icon type='bundleAdd' />
                            <span className={styles.description}>Additional bundle packs as a bonus</span>
                        </li>
                        <li className={styles.feature} style={{color: 'var(--premium-solid-color)'}}>
                            <Icon type='percent' />
                            <span className={styles.description}>Special prices and discounts</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export {
    PremiumInformationStage
};
